module.exports = __webpack_public_path__ + "media/Lightsoff.e0f2cdda.wav";